module.exports = __webpack_public_path__ + "static/alfonzo_g.b189b8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/alfonzo_g.png
// module id = 1711
// module chunks = 35783957827783